<template>
  <div class="bg-white py-2">
    <card-header :title="trans('dashboard.home.news')" :filter="false"/>
    <div v-if="newsItems.length > 0">
      <news-item v-for="newsItem in newsItems" :key="newsItem.title" :item="newsItem"/>
    </div>
    <div v-else class="py-4 news_card" style="display: block" v-text="trans('dashboard.home.no_news')"/>
  </div>
</template>
<script>
import CardHeader from '@/components/Dashboard/Card/Header';
import NewsItem from "@/components/Dashboard/News/Item";

export default {
  name: 'News',

  components: {
    NewsItem,
    CardHeader,
  },

  data: () => ({
    newsItems: [],
  }),

  beforeMount() {
    this.fetchNews();
  },

  methods: {
    fetchNews() {
      axios.get('/news').then(({data}) => {
        this.newsItems = data;
      });
    }
  }
}
</script>
